export enum UserBasicDataEnum {
  // NOME = "NOME",
  DATA_NASCIMENTO = "DATA_NASCIMENTO",
  SEXO = "SEXO",
  LADO_DOMINANTE = "LADO_DOMINANTE",
  TIPO_SANGUINEO = "TIPO_SANGUINEO",
  ALTURA = "ALTURA",
  PESO = "PESO",
  CODIGO_INEP = "CODIGO_INEP",
  AUXILIO_BRASIL = "AUXILIO_BRASIL",
}
